import { render, staticRenderFns } from "./SubscriptionAnnounce.vue?vue&type=template&id=2be65754&scoped=true"
import script from "./SubscriptionAnnounce.vue?vue&type=script&lang=ts"
export * from "./SubscriptionAnnounce.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionAnnounce.vue?vue&type=style&index=0&id=2be65754&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be65754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be65754')) {
      api.createRecord('2be65754', component.options)
    } else {
      api.reload('2be65754', component.options)
    }
    module.hot.accept("./SubscriptionAnnounce.vue?vue&type=template&id=2be65754&scoped=true", function () {
      api.rerender('2be65754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/SubscriptionAnnounce.vue"
export default component.exports